import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  selectValue: {
    id: 'p4uqnl',
    description: 'Default message in dropdown',
    defaultMessage: 'Select One',
  },
  suggestedMappingTooltip: {
    id: 'tbkcGD',
    description: 'Suggested mapping tooltip',
    defaultMessage: 'We automatically matched this field based on the field names. Check if it is correct.',
  },
  doNotImport: {
    description: 'Option to remove option from import',
    defaultMessage: 'Do not import',
    id: 'hlHh6z',
  },
});
